import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    container: {
      fontFamily: 'Montserrat',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '15px',
      width: '70%',
      borderRadius: palette.borderRadius.default,
      height: '93px',
      border: '2px dashed #959595',
      cursor: 'pointer',
      boxSizing: 'border-box',
      padding: '10px 20px',
      transition: '0.5s ease',
      transform: 'scale(1)',
      '&:hover': {
        transform: 'scale(1.1)'
      },
      '@media (max-width: 900px)': {
        width: '100%'
      },
      '&>p': {
        fontSize: '2rem',
        fontWeight: 600,
        color: palette.text.primary,
        textAlign: 'center'
      },
      '@media (max-width: 425px)': {
        '&>p': {
          fontSize: '1rem',
          fontWeight: 600,
          color: palette.text.primary
        }
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
